import { request } from "./request";

/**
 * 获取用户的对应的开发者列表
 */
export const getPublisherList = () =>
  request({
    method: "post",
    url: "/user/init"
  });

/**
 * 总收益
 */
export const getTotalRevenue = data =>
  request({
    method: "post",
    url: "/publisher/totalRevenue",
    data
  });

/**
 * 天收益
 */
export const getDayRevenue = data =>
  request({
    method: "post",
    url: "/publisher/dayRevenue",
    data
  });

/**
 * Top10包名
 */
export const getPkgRevenue = data =>
  request({
    method: "post",
    url: "/publisher/pkgRevenue",
    data
  });

/**
 * Top10国家
 */
export const getCountryRevenue = data =>
  request({
    method: "post",
    url: "/publisher/countryRevenue",
    data
  });

/**
 * 列表导出
 */
export const getPublisherOffersDownload = data =>
  request({
    method: "post",
    url: "/user/downloadOffersExcel",
    data,
    file: true,
    responseType: "blob"
  });
/**
 * 列表
 */
export const getPublisherOffers = data =>
  request({
    method: "post",
    url: "/user/publisherOffers",
    data
  });

// 登录
export const login = data => request({
  method: 'post',
  url: 'https://login.netmarvel.com/auth/login',
  data
})

/**
 * 退出登录
 */
export const logout = data =>
  request({
    method: "post",
    url: "/user/logout",
    data
  });

/**
 * OfferRevenue列表
 */
export const getOfferRevenueList = data =>
  request({
    method: "post",
    url: "/user/publisherOffersRevenue",
    data
  });

/**
 * OfferRevenue列表导出
 */
export const getOfferRevenueDownload = data =>
  request({
    method: "post",
    url: "/user/exportPublisherOffersRevenue",
    data,
    file: true,
    responseType: "blob"
  });


/**
 * OffersList列表
 */
export const getPublisherOffersList = data =>
request({
  method: "post",
  url: "/redskins/offerList",
  data
});

/**
 * OffersList列表 -  apply申请
 */
 export const getPublisherOffersListApply = data =>
 request({
   method: "post",
   url: "/redskins/apply",
   data
 });

/**
 * CPS Revenue列表
 */
export const getCpsRevenue = data =>
  request({
    method: "post",
    url: "/user/cpsRevenue",
    data
  });

/**
 * CPS Revenue导出
 */
export const exportCpsRevenue = data =>
  request({
    method: "post",
    url: data.url || "/user/exportCpsRevenue",
    data: {
      ...data,
      url: undefined
    },
    file: true,
    responseType: "blob"
  });
 